import { Post, Get, downFile } from '@/utils/axios'

/**
POST
/app/User/Customer/ChangePwd
修改密码
 */
export function changePwd(data) {
  return Post('/User/Customer/ChangePwd', data)
}

/**
POST
/app/User/ioos/add
设置Ioos
 */
export function iossAdd(data) {
  return Post('/User/ioos/add', data)
}

/**
POST
/app/User/ioos/delete
删除IOOS
 */
export function iossDelete(data) {
  return Post('/User/ioos/delete', data)
}

/**
POST
/app/User/CustomerAddress/Create
创建客户地址
 */
export function createCustomerAddress(data) {
  return Post('/User/CustomerAddress/Create', data)
}

/**
POST
/app/User/CustomerAddress/Update
修改客户地址
 */
export function updateCustomerAddress(data) {
  return Post('/User/CustomerAddress/Update', data)
}

/**
POST
/app/User/CustomerAddress/List
分页获取客户地址
 */
export function getPageCustomerAddress(data) {
  return Post('/User/CustomerAddress/List', data)
}

/**
POST
/app/User/CustomerAddress/Get
获取客户地址详情
 */
export function getCustomerAddress(data) {
  return Post('/User/CustomerAddress/Get', data)
}

/**
POST
/app/User/CustomerAddress/Delete
删除客户地址
 */
export function deleteCustomerAddress(data) {
  return Post('/User/CustomerAddress/Delete', data)
}

/**
 * 获取店铺列表
 * @param {*} data
 * @returns
 */
export function getStoreList(data) {
  return Post('/User/Stores/List', data)
}

/**
 * 获取所有店铺
 * @returns
 */
export function getStores() {
  return Get('/Common/GetStores')
}

/**
 * 获取普通订单账单列表
 * @param {*} data
 * @returns
 */
export function getMyInvoiceList(data) {
  return Post('/User/GetMyInvoiceList', data)
}

/**
 * 获取客户普通订单账单详情
 * @param {*} data
 * @returns
 */
export function getMyInvoiceInfo(data) {
  return Post('/User/GetMyInvoiceInfo', data)
}

/**
 * 银行转账
 * @param {*} data {amount, transferVoucher, remark}
 * @returns
 */
export function bankRecharge(data) {
  return Post('/User/Fund/Recharge', data)
}

/**
 * PayPal充值
 * @param {*} data {amount}
 * @returns
 */
export function createPayPal(data) {
  return Post('/User/Fund/CreatePayPal', data)
}

/**
 * 充值记录
 * @param {*} data
 * @returns
 */
export function getFundList(data) {
  return Post('/User/Fund/list', data)
}

/**
 * 充值记录
 * @param {*} data {ids:[]}
 * @returns
 */
export function rechargeInfo(data) {
  return Post('/User/Fund/RechargeInfo', data)
}

/**
 * 佣金信息获取
 * @returns
 */
export function getAffiliatesInfo() {
  return Post('/User/Affiliates/GetAffiliatesInfo')
}

/**
 * 佣金记录，月分组
 * @param {*} data {"pageNum": 0, "pageSize": 0, }
 * @returns
 */
export function getCommissionByMonthly(data) {
  return Post('/User/Affiliates/GetCommissionByMonthly', data)
}

/**
 * 佣金记录，按用户分
 * @param {*} data {"pageNum": 0, "pageSize": 0, }
 * @returns
 */
export function getDetailedCommission(data) {
  return Post('/User/Affiliates/GetDetailedCommission', data)
}

/**
 * 记录明细，按月查询
 * @param {*} data {"pageNum": 0, "pageSize": 0, }
 * @returns
 */
export function getCommissionByMonthlyAndCustomer(data) {
  return Post('/User/Affiliates/GetCommissionByMonthlyAndCustomer', data)
}

/**
 * vip 统计列表
 * @param {*} data
 * @returns
 */
export function getCustomerVipStatistics(data) {
  return Post('/User/Affiliates/GetCustomerVipStatistics', data)
}

/**
 * 子账号列表
 * @param {*} data {"pageNum": 0, "pageSize": 0}
 * @returns
 */
export function subAccountList(data) {
  return Post('/User/Account/SubAccountList', data)
}

/**
 * 创建子账号
 * @param {*} data {"pageNum": 0, "pageSize": 0, }
 * @returns
 */
export function createSubAccount(data) {
  return Post('/User/Account/CreateSubAccount', data)
}

/**
 * 子账号修改密码
 * @param {*} data {"id": 0, "passWord": 0, }
 * @returns
 */
export function updateSubAccountPass(data) {
  return Post('/User/Account/UpdateSubAccountPass', data)
}

/**
 * 子账号修改店铺
 * @param {*} data {"id": 0, "stores": [], }
 * @returns
 */
export function updateSubAccountStoresAuthority(data) {
  return Post('/User/Account/UpdateSubAccountStoresAuthority', data)
}

/**
 * 子账号删除
 * @param {*} data {"id": 0}
 * @returns
 */
export function deleteSubAccount(id) {
  return Post('/User/Account/DeleteSubAccount', { id })
}

/**
 * 子账号状态修改
 * @param {*} data {"id": 0}
 * @returns
 */
export function updateSubAccountStatus(data) {
  return Post('/User/Account/UpdateSubAccountStatus', data)
}

/**
 * 子账号权限获取
 * @param {*} data
 * @returns
 */
export function getUserAuthoritys(data) {
  return Get('/User/Account/GetUserAuthoritys', data)
}

/**
 * 获取运输模板
 * @param {*} data {"id": 0}
 * @returns
 */
export function getTemplates() {
  return Post('/User/Rule/GetTemplates')
}

/**
 * 获取运输方式
 * @param {*} data {"id": 0}
 * @returns
 */
export function getShippingMethod(data) {
  return Post('/User/Rule/GetShippingMethod', data)
}

/**
 * 修改运输规则
 * @param {*} data
 * @returns
 */
export function eidtRule(data) {
  return Post('/User/Rule/edit', data)
}

/**
 * 获取运输规则
 * @param {*} data {pageNum, pageSize}
 * @returns
 */
export function getRule(data) {
  return Get('/User/Rule/list', data)
}

/**
 * 删除运输规则
 * @param {*} id
 * @returns
 */
export function delRule(id) {
  return Post('/User/Rule/delete', { id })
}

/**
 * 创建工单
 * @param {*} data
 * @returns
 */
export function createWorkOrder(data) {
  return Post('/User/WorkOrder/Create', data)
}

/**
 * 回复工单
 * @param {*} data
 * @returns
 */
export function replyWorkOrder(data) {
  return Post('/User/WorkOrder/Reply', data)
}

/**
 * 结束工单
 * @param {*} data
 * @returns
 */
export function endAppWorkOrder(id) {
  return Post('/User/WorkOrder/EndAppWorkOrder', { id })
}

/**
 * 工单列表
 * @param {*} data
 * @returns
 */
export function getWorkOrderList(data) {
  return Post('/User/WorkOrder/List', data)
}

/**
 * 获取工单详情
 * @param {*} data
 * @returns
 */
export function getWorkOrderInfo(id) {
  return Post('/User/WorkOrder/WorkInfo', { id })
}

/**
 * 删除工单
 * @param {*} id
 * @returns
 */
export function delWorkOrder(id) {
  return Post('/User/WorkOrder/Delete', { id })
}

/**
 * 编辑发票地址
 * @param {*} data
 * @returns
 */
export function editInvoiceAddress(data) {
  return Post('/User/InvoiceAddress/edit', data)
}

/**
 * 获取发票地址
 * @param {*} data
 * @returns
 */
export function getInvoiceAddress() {
  return Get('/User/InvoiceAddress/Info')
}

export function withdrawApply(data) {
  return Post('/User/Fund/WithdrawApply', data)
}


/**
 * 获取发票地址
 * @param {*} data
 * @returns
 */
export function getBalanceLogs(query) {
  return Get('/User/GetBalanceLogs', query)
} 
/**
 * 填写备注
 * @param {*} data
 * @returns
 */
export function UpdateCustomerBalanceLogCustomerRemark(query) {
  return Post('/User/UpdateCustomerBalanceLogCustomerRemark', query)
}
// 资金记录导出
export async function GetCustomerBalanceLogsExport(param) {
  await downFile('/User/GetCustomerBalanceLogsExport', { ...param })
}
/**
 * 获取权限
 * @param {*} data
 * @returns
 */
export function GetCustomerPower(query) {
  return Get('/User/GetCustomerPower', query)
} 
export function GetChildCustomers(query) {
  return Get('/User/GetChildCustomers', query)
}

export function GetTaxConfig(query) {
  return Get('/User/GetTaxConfig', query)
} 
export function GetTaxCodes(query) {
  return Get('/User/GetTaxCodes', query)
}
export function SetTaxCode(data) {
  return Post('/User/SetTaxCode', data)
}
export function DeleteTaxCode(data) {
  return Post('/User/DeleteTaxCode', data)
}
export function GetMyExtraOrInventoryInvoiceList(data) {
  return Post('/User/GetMyExtraOrInventoryInvoiceList', data)
}
// 获取工单付款
export function GetTicketsPayment(data) {
  return Post('/User/GetTicketsPayment', data)
}
// 获取工单付款详情
export function GetTicketsPaymentInfos(data) {
  return Post('/User/GetTicketsPaymentInfos', data)
}
